import { render, staticRenderFns } from "./explain.vue?vue&type=template&id=d099552a&scoped=true&"
import script from "./explain.vue?vue&type=script&lang=js&"
export * from "./explain.vue?vue&type=script&lang=js&"
import style0 from "./explain.vue?vue&type=style&index=0&id=d099552a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d099552a",
  null
  
)

export default component.exports